import gql from 'graphql-tag'

export const GET_ANALYTICS_DEVICES_BY_WORKSPACE_ID_Q = gql`
  query GetAnalyticsDevicesByWorkspaceId($workspaceId: String!) {
    getAnalyticsDevicesByWorkspaceId(workspaceId: $workspaceId) {
      deviceId
      name
      deviceType
      workspace {
        id
        name
      }
    }
  }
`
